export default __webpack_public_path__ + "static/media/about2.45f1e299.jpg";